<template>
  <div class="Conference_room">
    <el-button type="primary" @click="dialogVisible = true" style="margin-left: 20px;margin-top: 20px;"> + 新增会议室</el-button>


    <el-select v-model="HistoryFlag" placeholder="请选择活动区域" style="margin-left:20px;" @change="btrdd">
      <el-option label="包括历史数据" value="1"></el-option>

      <el-option label="不包括历史数据" value="0"></el-option>

    </el-select>

    <!-- <el-button type="primary" @click="xsxs()" style="margin-left: 20px;margin-top: 20px;">跳转</el-button> -->

    <ul class="room">
      <li v-for="item in room_list" :key="item.KeyNo">
        <h2>{{item.Name}}</h2>
        <p>{{ item.TencentNo }}</p>
        <span @click.stop="_copy(item.TencentNo)" class="el-icon-document-copy"></span>
        <el-button class="write" type="primary" icon="el-icon-edit" @click="xgroom(item.KeyNo)"></el-button>
        <el-button class="goin" type="primary" @click="goin(item.KeyNo, item.ValidStartDate)">进入会议室</el-button>
      </li>
    </ul>
    <el-dialog title="新增会议室" :visible.sync="dialogVisible" width="700px" :before-close="handleClose" style="margin-top: -4vh !important;">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

        <el-form-item label="会议室名称" prop="Name">
          <el-input v-model="ruleForm.Name" placeholder="请输入会议室名称"></el-input>
        </el-form-item>
        
        <el-form-item label="会议室地址" prop="TencentLink">
          <el-input v-model="ruleForm.TencentLink" placeholder="请输入会议室地址"></el-input>
        </el-form-item>

        <el-form-item label="视频会议id" prop="TencentNo">
          <el-input v-model="ruleForm.TencentNo" placeholder="请输入视频会议id"></el-input>
        </el-form-item>

        <el-form-item label="开放时间" prop="value1" style="position: relative;">

          <el-date-picker v-model="ruleForm.value1" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          
        </el-form-item>

        <el-form-item label="上午时段" style="position: relative;">

          <el-time-picker v-model="ruleForm.type1" format='HH:mm' value-format="HH:mm" is-range range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" unlink-panels :clearable="aaa"></el-time-picker>

          <el-select v-if="ruleForm.type1" v-model="InterviewMorning" placeholder="请选择访谈人" style="position: absolute;top: 0px;left: 360px;">
            <el-option v-for="item in data" :key="item.UserID" :label="item.RealName" :value="item.UserID"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="下午时段" style="position: relative;">
          <el-time-picker v-model="ruleForm.type2" format='HH:mm' value-format="HH:mm" is-range range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" unlink-panels :clearable="aaa"></el-time-picker>
          <el-select v-if="ruleForm.type2" v-model="InterviewNoon" placeholder="请选择访谈人" style="position: absolute;top: 0px;left: 360px;">
            <el-option v-for="item in data" :key="item.UserID" :label="item.RealName" :value="item.UserID"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="晚上时段" style="position: relative;">
          <el-time-picker v-model="ruleForm.type3" format='HH:mm' value-format="HH:mm" is-range range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" unlink-panels :clearable="aaa"></el-time-picker>
          <el-select v-if="ruleForm.type3" v-model="InterviewEvening" placeholder="请选择访谈人" style="position: absolute;top: 0px;left: 360px;">
            <el-option v-for="item in data" :key="item.UserID" :label="item.RealName" :value="item.UserID"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="访谈时长" prop="InterviewTime">
      <el-input 
          v-model="ruleForm.InterviewTime" 
          type="text" 
          @input.native="validateNumber($event, 'InterviewTime')">
      </el-input>
    </el-form-item>

    <el-form-item label="休息时长" prop="RelaxTime">
      <el-input 
          v-model="ruleForm.RelaxTime" 
          type="text" 
          @input.native="validateNumber($event, 'RelaxTime')">
      </el-input>
    </el-form-item>

        <p style="color: red;margin-left: 100px;margin-top: -10px;">建议访谈时长:15分钟，休息时长：5分钟</p>

        <el-form-item label="启用" prop="IsActive">
          <el-radio-group v-model="ruleForm.IsActive">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button :loading="iscontinuous" type="primary" @click="submitForm('ruleForm')">新增</el-button>
        </el-form-item>

      </el-form>
    </el-dialog>
    <el-dialog title="修改会议室信息" :visible.sync="xgdialogVisible" width="40%" :before-close="handleClose" style="margin-top: -4vh !important;">

    <el-form :model="xgruleForm" :rules="rules" ref="xgruleForm" label-width="100px" class="demo-ruleForm">

      <el-form-item label="会议室名称" prop="Name">
        <el-input v-model="xgruleForm.Name"></el-input>
      </el-form-item>

      <el-form-item label="会议室地址" prop="TencentLink">
        <el-input v-model="xgruleForm.TencentLink"></el-input>
      </el-form-item>

      <el-form-item label="视频会议id" prop="TencentNo">
        <el-input v-model="xgruleForm.TencentNo"></el-input>
      </el-form-item>

      <el-form-item label="开放时间" prop="value1">
        <el-date-picker disabled v-model="xgruleForm.value1" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="上午时段" prop="type1" style="position: relative;">
        <el-time-picker disabled v-model="xgruleForm.type1" format='HH:mm' value-format="HH:mm" is-range range-separator="至" :start-placeholder="xgruleForm.type1[0]" :end-placeholder="xgruleForm.type1[1]" placeholder="选择时间范围" unlink-panels></el-time-picker>

        <el-select disabled v-model="InterviewMorning2" placeholder="请选择访谈人" style="position: absolute;top: 0px;left: 360px;">
          <el-option v-for="item in data" :key="item.UserID" :label="item.RealName" :value="item.UserID"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="下午时段" prop="type2" style="position: relative;">
        <el-time-picker disabled v-model="xgruleForm.type2" format='HH:mm' value-format="HH:mm" is-range range-separator="至" :start-placeholder="xgruleForm.type2[0]" :end-placeholder="xgruleForm.type2[1]" placeholder="选择时间范围" unlink-panels></el-time-picker>

        <el-select disabled v-model="InterviewNoon2" placeholder="请选择访谈人" style="position: absolute;top: 0px;left: 360px;">
          <el-option v-for="item in data" :key="item.UserID" :label="item.RealName" :value="item.UserID"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item  label="晚上时段" prop="type3" style="position: relative;">
        <el-time-picker disabled v-model="xgruleForm.type3" format='HH:mm' value-format="HH:mm" is-range range-separator="至" :start-placeholder="xgruleForm.type3[0]" :end-placeholder="xgruleForm.type3[1]" placeholder="选择时间范围" unlink-panels></el-time-picker>

        <el-select disabled v-model="InterviewEvening2" placeholder="请选择访谈人" style="position: absolute;top: 0px;left: 360px;">
          <el-option v-for="item in data" :key="item.UserID" :label="item.RealName" :value="item.UserID"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="访谈时长" prop="InterviewTime">
        <el-input disabled v-model="xgruleForm.InterviewTime"></el-input>
      </el-form-item>

      <el-form-item label="休息时长" prop="delivery">
        <el-input disabled v-model="xgruleForm.RelaxTime"></el-input>
      </el-form-item>

      <p style="color: red;margin-left: 100px;margin-top: -10px;">建议访谈时长:15分钟，休息时长：5分钟</p>

      <el-form-item label="启用" prop="delivery">
        <el-radio-group v-model="xgruleForm.IsActive">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="xgsubmitForm('xgruleForm')">修改</el-button>
      </el-form-item>

    </el-form>
  </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      iscontinuous:false,
      HistoryFlag:'1',
      aaa:true,
      data: [],
      InterviewMorning :'',
      InterviewNoon: '',
      InterviewEvening: '',
      InterviewMorning2: '',
      InterviewNoon2: '',
      InterviewEvening2: '',
      dialogVisible: false,
      xgdialogVisible: false,
      room_list:[],
      ruleForm: {
        Name: '',//会议室名称
        TencentLink: '',//腾讯会议链接
        TencentNo: '',//视频会议id
        value1: [],//开放时间
        type1: [new Date(2016, 9, 10, 8, 0), new Date(2016, 9, 10, 12, 0)],//上午时间段
        type2: [new Date(2016, 9, 10, 13, 0), new Date(2016, 9, 10, 17, 0)],//下午时间段
        type3: [new Date(2016, 9, 10, 18, 0), new Date(2016, 9, 10, 22, 0)],//晚上时间段
        RelaxTime: '',//休息时长
        InterviewTime: '',//访谈时长
        IsActive: 1,//会议室是否启用1-启用0-禁用
      },
      xgruleForm: {
        KeyNo: '',
        Name: '',//会议室名称
        TencentLink: '',//腾讯会议链接
        TencentNo: '',//视频会议id
        value1: [],//开放时间
        type1: [new Date(2016, 9, 10, 8, 0), new Date(2016, 9, 10, 12, 0)],//上午时间段
        type2: [new Date(2016, 9, 10, 13, 0), new Date(2016, 9, 10, 17, 0)],//下午时间段
        type3: [new Date(2016, 9, 10, 18, 0), new Date(2016, 9, 10, 22, 0)],//晚上时间段
        RelaxTime: '', //休息时长
        InterviewTime: '',//访谈时长
        IsActive: 1,//会议室是否启用 1-启用 0-禁用
      },
      rules: {
        Name: [
          { required: true, message: '请输入会议室名称', trigger: 'blur' },
        ],
        TencentLink: [
          { required: true, message: '请输入视频会议链接', trigger: 'blur' }
        ],
        TencentNo: [
          { required: true, message: '请输入视频会议id', trigger: 'blur' }
        ],
        value1: [
          { required: true, message: '请选择开放时间',}
        ],
        type1: [
          {  required: true, message: '请选择上午时间段', }
        ],
        type2: [
          {  required: true, message: '请选择下午时间段', }
        ],
        type3: [
          {  required: true, message: '请选择晚上时间段',  }
        ],
        InterviewTime: [
          { required: true, message: '请输入访谈时长', trigger: 'blur' },
        ],
        RelaxTime: [
          { required: true, message: '请输入休息时长', trigger: 'blur' },
        ],
      }
    }
  },
  mounted() {
    this.GetInterviewRoomList();
    this.$Http_Post('EmphasisClarification/GetConsultantList').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data 
      } else {
        this.Global.request_failure(res.Message)
      }
    })
  },
  methods: {
    validateNumber(event, field) {
      if (!event || !event.target) {
        return; // 确保 event.target 存在
      }

      const value = event.target.value;
      const numericValue = value.replace(/[^0-9]/g, ''); // 过滤非数字字符

      // 更新 ruleForm 中的相应字段
      this.ruleForm[field] = numericValue ? Number(numericValue) : null; // 转换为数字或设置为 null
    },
    btrdd(){
      this.GetInterviewRoomList();
    },
    _copy(context) {{
        //创建输入框元素
        let oInput = document.createElement('input');
        //将想要复制的值
        oInput.value = context;
        //页面底部追加输入框
        document.body.appendChild(oInput);
        //选中输入框
        oInput.select();
        //执行浏览器复制命令
        document.execCommand('Copy');
        //弹出复制成功信息
        this.$message.success('复制成功');
        //复制后移除输入框
        oInput.remove();
      }
    },
    xgroom(KeyNo) {
      this.$Http_Post('EmphasisClarification/GetInterviewRoomInfo',{ KeyNo : KeyNo }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.xgdialogVisible = true;
          this.InterviewMorning2 = res.Data.InterviewMorning,
          this.InterviewNoon2 = res.Data.InterviewNoon,
          this.InterviewEvening2 = res.Data.InterviewEvening,
          this.xgruleForm = {
            KeyNo: res.Data.KeyNo,
            Name: res.Data.Name,//会议室名称
            TencentLink: res.Data.TencentLink,//腾讯会议链接
            TencentNo: res.Data.TencentNo,//视频会议id
            value1:[res.Data.ValidStartDate, res.Data.ValidEndDate],//开放时间
            type1:[res.Data.MorningBegin, res.Data.MorningEnd],//上午时间段
            type2:[res.Data.NoonBegin,res.Data.NoonEnd],//下午时间段
            type3:[res.Data.EveningBegin, res.Data.EveningEnd],//晚上时间段
            RelaxTime: res.Data.RelaxTime,//休息时长
            InterviewTime: res.Data.InterviewTime,//访谈时长
            IsActive: res.Data.IsActive,//会议室是否启用1-启用 0-禁用
          }
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    GetInterviewRoomList(){
      this.$Http_Post('EmphasisClarification/GetInterviewRoomList', {HistoryFlag:this.HistoryFlag}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.room_list = res.Data;
        } else {
          this.Global.request_failure(res.Message)
        }
      })
    },
    goin(id, ValidStartDate) {
      let routeData = this.$router.resolve({
        path: '/Interview/Interview_typesetting',
        query: { id: id , ValidStartDate : ValidStartDate },
      })
      this.$router.push(routeData.href)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (this.ruleForm.type1) {} else {this.ruleForm.type1 = ['','']}
        if (this.ruleForm.type2) {} else {this.ruleForm.type2 = ['','']}
        if (this.ruleForm.type3) {} else {this.ruleForm.type3 = ['','']}
        if (valid) {
          this.iscontinuous = true
          this.$Http_Post('EmphasisClarification/SumbitInterviewRoomInfo', {
            Name: this.ruleForm.Name,
            TencentLink: this.ruleForm.TencentLink,
            TencentNo: this.ruleForm.TencentNo,
            ValidStartDate: this.ruleForm.value1[0],
            ValidEndDate: this.ruleForm.value1[1],
            InterviewTime: Number(this.ruleForm.InterviewTime),
            RelaxTime: Number(this.ruleForm.RelaxTime),
            IsActive: Number(this.ruleForm.IsActive),
            InterviewMorning: this.InterviewMorning,
            InterviewNoon: this.InterviewNoon,
            InterviewEvening: this.InterviewEvening,
            MorningBegin: this.ruleForm.type1[0]=='Mon Oct 10 2016 08:00:00 GMT+0800 (中国标准时间)'? '08:00': this.ruleForm.type1[0],
            MorningEnd: this.ruleForm.type1[1] == 'Mon Oct 10 2016 12:00:00 GMT+0800 (中国标准时间)' ? '12:00' : this.ruleForm.type1[1],
            NoonBegin: this.ruleForm.type2[0] == 'Mon Oct 10 2016 13:00:00 GMT+0800 (中国标准时间)' ? '13:00' : this.ruleForm.type2[0],
            NoonEnd: this.ruleForm.type2[1] == 'Mon Oct 10 2016 17:00:00 GMT+0800 (中国标准时间)' ? '17:00' : this.ruleForm.type2[1],
            EveningBegin: this.ruleForm.type3[0] == 'Mon Oct 10 2016 18:00:00 GMT+0800 (中国标准时间)' ? '18:00' : this.ruleForm.type3[0],
            EveningEnd: this.ruleForm.type3[1] == 'Mon Oct 10 2016 22:00:00 GMT+0800 (中国标准时间)' ? '22:00' : this.ruleForm.type3[1],
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.iscontinuous = false
              this.Global.request_successful(res.Message);
              this.dialogVisible = false;
              this.GetInterviewRoomList();
            } else {
              this.iscontinuous = false
              this.Global.request_failure(res.Message);
            }
          })
        } else {
          console.log('error submit!');
          return false;
        }
      });
    },

    xgsubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('EmphasisClarification/SumbitInterviewRoomInfo', { 
            Name: this.xgruleForm.Name,
            TencentLink: this.xgruleForm.TencentLink,
            TencentNo: this.xgruleForm.TencentNo,
            ValidStartDate: this.xgruleForm.value1[0],
            ValidEndDate: this.xgruleForm.value1[1],
            MorningBegin: this.xgruleForm.type1[0],
            MorningEnd: this.xgruleForm.type1[1],
            NoonBegin: this.xgruleForm.type2[0],
            NoonEnd: this.xgruleForm.type2[1],
            EveningBegin: this.xgruleForm.type3[0],
            EveningEnd: this.xgruleForm.type3[1],
            InterviewTime: Number(this.xgruleForm.InterviewTime),
            RelaxTime: Number(this.xgruleForm.RelaxTime),
            IsActive: Number(this.xgruleForm.IsActive),
            KeyNo: this.xgruleForm.KeyNo,
            InterviewMorning: this.InterviewMorning2,
            InterviewNoon: this.InterviewNoon2,
            InterviewEvening: this.InterviewEvening2,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.Global.request_successful(res.Message);
              this.xgdialogVisible = false;
            } else {
              this.Global.request_failure(res.Message)
            }
          })
        } else {
          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(_ => {
        done();
      })
      .catch(_ => { });
    }
  },
}
</script>
<style>
  .Conference_room{background-color: #fff;width: 100%;height: 100%;}
  .Conference_room .room{width: 100%;margin-left: 20px;margin-top: 20px;}
  .Conference_room .room li {float: left;width: 22%;margin-right: 2%;height: 220px;    background-image: url('../../assets/64560de8818bbf991e2b171b.png');background-size: 100% 100%;border-radius: 10px;position: relative;margin-top: 20px;}
  .Conference_room .room li:hover{box-shadow:0 0 5px rgb(124, 235, 255), 0 0 10px rgb(124, 235, 255), 0 0 15px rgb(124, 235, 255)}
  .Conference_room .room li h2{position: absolute;top: 10px;left: 20px;font-size: 20px;}
  .Conference_room .room li p{position: absolute;top: 50px;left: 20px;font-size: 16px;color: rgba(40, 40, 40, 1);}
  .Conference_room .room li>span{position: absolute;top: 53px;left: 150px;font-size: 16px;color: rgba(40, 40, 40, 1);}
  .Conference_room .room li .write{position: absolute;bottom: 20px;right: 160px;font-size: 16px;}
  .Conference_room .room li .goin{position: absolute;bottom: 20px;right: 20px;width: 120px;}
</style>
